import React from 'react';

const STATUS_COLORS = {
  live: '#34C759',
  degraded: '#FF9F0A',
  stale: '#FF9F0A',
  offline: '#FF3B30',
  error: '#FF3B30',
};

const SOURCE_DOMAINS = {
  noaa_swpc: 'Space Weather',
  celestrak: 'Orbital',
  iss_tracker: 'Orbital',
  nasa_donki: 'Solar Activity',
  nasa_apod: 'Astronomy',
};

function timeAgo(isoStr) {
  if (!isoStr) return '—';
  try {
    const diff = (Date.now() - new Date(isoStr).getTime()) / 1000;
    if (diff < 60) return `${Math.floor(diff)}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  } catch { return '—'; }
}

export default function SourceHealthMatrix({ scoring }) {
  const sourceHealth = scoring?.sourceHealth || {};

  return (
    <div className="orion-shm" data-testid="source-health-matrix">
      <div className="orion-gauge-header">
        <span className="orion-gauge-title">SOURCE HEALTH</span>
        <span className="orion-shm-state" data-testid="monitoring-state" style={{
          color: scoring?.monitoringState === 'LIVE' ? '#34C759' :
                 scoring?.monitoringState === 'DEGRADED' ? '#FF9F0A' : '#FF3B30'
        }}>
          {scoring?.monitoringState || 'UNKNOWN'}
        </span>
      </div>
      <div className="orion-shm-grid">
        {Object.entries(sourceHealth).map(([name, health]) => {
          const color = STATUS_COLORS[health.status] || '#52525B';
          return (
            <div key={name} className="orion-shm-row" data-testid={`source-health-${name}`}>
              <div className="orion-shm-dot" style={{ background: color, boxShadow: `0 0 4px ${color}40` }} />
              <div className="orion-shm-info">
                <span className="orion-shm-name">{name.replace(/_/g, ' ').toUpperCase()}</span>
                <span className="orion-shm-domain">{SOURCE_DOMAINS[name] || ''}</span>
              </div>
              <span className="orion-shm-status" style={{ color }}>{health.status?.toUpperCase()}</span>
              <span className="orion-shm-age">{timeAgo(health.lastSuccess)}</span>
              {health.degraded_reason && (
                <span className="orion-shm-age" style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {health.degraded_reason}
                </span>
              )}
            </div>
          );
        })}
      </div>
      {scoring?.affectedDomains?.length > 0 && (
        <div className="orion-shm-affected" data-testid="affected-domains">
          AFFECTED: {scoring.affectedDomains.join(', ')}
        </div>
      )}
    </div>
  );
}
